export default __webpack_public_path__ + "static/media/ecma.f3a0db74.jpeg";